<template>
  <!-- <div v-if="$store.state.NAV != null">
    <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav>
  </div> -->
  <router-view/>
</template>
<script>
import '@/assets/stars.css'
import { onBeforeMount } from 'vue'
import { useStore } from 'vuex'
import {uid} from 'uid'
export default {
  created() {
    this.$store.state.Year = new Date(Date.now()).toLocaleDateString("en-uk", {year: "numeric"} )
    this.$store.state.sitetime = new Date(Date.now()).toLocaleDateString("en-uk" )
    this.$store.state.RequestID = this.$store.state.Year+"-"+uid(12)
    this.$store.state.checksum = uid(4) 
  },
  setup() {
    const store = useStore()
    onBeforeMount(() => {
      store.dispatch('fetchUser')
    })
  },
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
